module.exports = __webpack_public_path__ + "img/persians-barbarian.5fdb3790.png";